document.addEventListener('DOMContentLoaded', (event) => {
  const key = 'gclid';

  try {
    // Store the gclid in localstorage
    (() => {
      const params = new URLSearchParams(window.location.search)
      const gclidParam = params.get('gclid')

      if (gclidParam) {
        localStorage.setItem(key, JSON.stringify({
          value: gclidParam,
          recordedAt: new Date().getTime(),
        }));
      }
    })();

    // Inject the gclid into the signup form
    (() => {
      const elem = document.getElementById('signup_gclid');

      if (elem) {
        const entry = JSON.parse(localStorage.getItem(key));
        const expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds
        const isExpired = entry.recordedAt + expiryPeriod < new Date().getTime();

        if (!isExpired) {
          elem.value = entry.value;
        }
      }
    })()
  } catch(e) {
    console.warn(e);
  }
});
